import axios from 'axios';
import { getConfig } from '../config';
import type { GpKeywordCpSearch } from '../models/Coupang';

export interface ApiResponse {
  products: GpKeywordCpSearch[];
}

export class CpSearchClient {
  private readonly baseUrl: string;

  constructor() {
    this.baseUrl = getConfig().apiUrl;
  }

  // Get GP Keyword CP Search results by Glowpick Product ID
  async getGpKeywordCpSearch(gpProductId: string): Promise<ApiResponse> {
    const url = `${this.baseUrl}/sourcing/gpKeywordCpSearch?gpProductId=${gpProductId}`;
    console.info('🌐 API Request:', url);
    const response = await axios.get(url);

    // The server returns { products: GpKeywordCpSearch[] }
    console.info(`🌐 API response with ${response.data.products?.length || 0} products received`);
    return response.data;
  }

  // Delete GP Keyword CP Search results
  async deleteGpKeywordCpSearch(gpProductId: string): Promise<{ success: boolean; message?: string }> {
    const url = `${this.baseUrl}/sourcing/gpKeywordCpSearch?gpProductId=${gpProductId}`;
    console.info('🗑️ API Request (DELETE):', url);

    try {
      await axios.delete(url);
      console.info('✅ GP Keyword CP Search results deleted successfully');
      return { success: true };
    } catch (error) {
      console.error('❌ Failed to delete GP Keyword CP Search results:', error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  }
}

export const cpSearchClient = new CpSearchClient();
